import CookieSettingsButton from './CookieSettingsButton';

export default CookieSettingsButton;
